export const INVITATIONS_LOADED = "invitations/invitationsLoaded"
export const INVITATIONS_ADDED = "invitations/invitationsAdded"
export const INVITATION_UPDATED = "invitations/invitationUpdated"
export const INVITATION_DELETED = "invitations/invitationDeleted"
export const INVITATIONS_DELETED = "invitations/invitationsDeleted"